// import { Component, OnInit } from '@angular/core';

// @Component({
//   selector: 'app-unarchivedata',
//   templateUrl: './unarchivedata.component.html',
//   styleUrls: ['./unarchivedata.component.scss']
// })
// export class UnarchivedataComponent implements OnInit {

//   constructor() { }

//   ngOnInit() {
//   }

// }

import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-unarchivedata',
  templateUrl: './unarchivedata.component.html',
  styleUrls: ['./unarchivedata.component.scss']
})
export class UnarchivedataComponent implements OnInit, OnDestroy {

  projectId: string = '';
  isSubmitting: boolean = false;
  currentAction: string = '';

  // Unarchive timer
  unarchiveStartTime: number = 0;
  unarchiveElapsedSeconds: number = 0;
  unarchiveTimer: any = null;

  constructor(
    private userService: UserService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.stopTimer();
  }

  Unarchive(form: NgForm): void {

    // Validate Project ID
    if (!this.projectId || this.projectId.trim() === '') {

      if (form.controls['projectId']) {
        form.controls['projectId'].markAsTouched();
      }

      this.toastr.warning(
        'Please enter Project Id.',
        '',
        {
          progressBar: true,
          timeOut: 4000
        }
      );
      return;
    }

    var projectIdValue = this.projectId.trim();

    this.isSubmitting = true;
    this.currentAction = 'unarchive';

    // Start unarchive timer
    this.unarchiveStartTime = new Date().getTime();
    this.unarchiveElapsedSeconds = 0;

    this.stopTimer();

    this.unarchiveTimer = setInterval(() => {
      if (this.isSubmitting && this.currentAction === 'unarchive') {
        var currentTime = new Date().getTime();
        this.unarchiveElapsedSeconds =
          Math.floor(
            (currentTime - this.unarchiveStartTime) / 1000
          );
      }
    }, 1000);

    console.log('Unarchive Project ID:', projectIdValue);

    this.userService.unarchivesurvey(projectIdValue)
      .subscribe(

        // SUCCESS
        (data: any) => {

          console.log('Unarchive API Response:', data);

          this.isSubmitting = false;
          this.currentAction = '';

          // Stop unarchive timer
          this.stopTimer();

          if (data && data.success === true) {
            this.toastr.success(
              data.message || 'Unarchive Successfully',
              '',
              {
                progressBar: true,
                timeOut: 5000
              }
            );

            this.projectId = '';
            form.resetForm();

          } else {
            var message = 'Unable to unarchive client survey.';

            if (data && data.message) {
              message = data.message;
            }
            this.toastr.warning(
              message,
              'Unarchive Failed',
              {
                progressBar: true,
                timeOut: 6000
              }
            );
          }
        },

        // ERROR
        (error: any) => {

          console.error('Unarchive API Error:', error);

          this.isSubmitting = false;
          this.currentAction = '';

          // Stop unarchive timer
          this.stopTimer();

          var errorMessage = 'Error while unarchiving client survey.';

          /*
           * API returns:
           *
           * {
           *   success: false,
           *   message: "Error while unarchiving client survey.",
           *   error: "Timeout expired..."
           * }
           */

          if (error && error.error) {

            // API message
            if (error.error.message) {
              errorMessage = error.error.message;
            }

            // SQL error / timeout
            if (error.error.error) {

              var sqlError =
                error.error.error.toString();

              console.error(
                'SQL/API Error Detail:',
                sqlError
              );

              // SQL timeout
              if (
                sqlError
                  .toLowerCase()
                  .indexOf('timeout') !== -1
              ) {
                errorMessage =
                  'Unarchive operation timed out. ' +
                  'The server is still processing the data ' +
                  'or the operation took too long.';
              }
              else if (!error.error.message) {
                errorMessage = sqlError;
              }
            }
          }

          // HTTP status handling
          if (error && error.status === 401) {
            errorMessage = 'Your session has expired. Please login again.';
          }
          else if (error && error.status === 403) {
            errorMessage = 'You are not authorized to unarchive this data.';
          }
          else if (error && error.status === 404) {
            errorMessage = 'Unarchive API was not found.';
          }
          else if (error && error.status === 500) {

            /*
             * Keep the API message if available.
             * SQL detail is logged in console.
             */

            if (
              error.error &&
              error.error.message
            ) {
              errorMessage =
                error.error.message;
            }
          }

          this.toastr.error(
            errorMessage,
            'Unarchive Failed',
            {
              progressBar: true,
              timeOut: 10000
            }
          );
        }
      );
  }

  private stopTimer(): void {
    if (this.unarchiveTimer) {
      clearInterval(this.unarchiveTimer);
      this.unarchiveTimer = null;
    }
  }

  // Format unarchive timer as MM:SS
  getUnarchiveTime(): string {

    var minutes = Math.floor(this.unarchiveElapsedSeconds / 60);
    var seconds = this.unarchiveElapsedSeconds % 60;

    var minuteText =
      minutes < 10
        ? '0' + minutes
        : minutes.toString();

    var secondText =
      seconds < 10
        ? '0' + seconds
        : seconds.toString();

    return minuteText + ':' + secondText;
  }
}
